// extracted by mini-css-extract-plugin
export default {"home_page_wrapper":"styles_home_page_wrapper__mqucs"};